module.exports = __webpack_public_path__ + "img/course102_curriculum.120d0128.png";